import { USPSMIDTypeEnum } from '@app/app.enum';
import environment from '@app/environments/environment';
import * as models from '@app/models';
import { ISystemConfigs, ISystemConfigsResponse, IUSPSMIDsCount } from '@app/models';
import axios, { CancelToken } from 'axios';
import { Injectable } from 'injection-js';

@Injectable()
export class SystemConfigService {
	private baseUrl = environment.apiGateway.apiUrl;
	private systemConfigUrl = '';
	private uspsMIDUrl = '';
	constructor() {
		this.systemConfigUrl = this.baseUrl + 'SystemConfig/';
		this.uspsMIDUrl = this.baseUrl + 'USPSMID/';
	}

	public async getAPIVersion(cancelToken?: CancelToken): Promise<models.ISystemConfigAPIVersion> {
		try {
			const url = this.systemConfigUrl + `APIVersion`;
			const res = await axios.get<models.ISystemConfigAPIVersion>(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async getSequenceNumberRange(cancelToken?: CancelToken): Promise<models.ISequenceNumberRange> {
		try {
			const url = this.systemConfigUrl + `SequenceNumberRange`;
			const res = await axios.get<models.ISequenceNumberRange>(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async getFedExSequenceNumberRange(cancelToken?: CancelToken): Promise<models.ISequenceNumberRange> {
		try {
			const url = this.systemConfigUrl + `SequenceNumberRange/FedEx`;
			const res = await axios.get<models.ISequenceNumberRange>(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async getCreditCardFeeAndMasterMID(cancelToken?: CancelToken): Promise<ISystemConfigsResponse> {
		try {
			const url = this.systemConfigUrl + 'Admin/';
			const res = await axios.get<ISystemConfigsResponse>(url, {
				cancelToken,
			});

			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async updateCreditCardFee(data: ISystemConfigs, cancelToken?: CancelToken): Promise<ISystemConfigsResponse> {
		try {
			const url = this.systemConfigUrl + 'Admin/';
			const res = await axios.put<ISystemConfigsResponse>(url, data, {
				cancelToken,
			});

			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async importUSPSMID(data: any, type: USPSMIDTypeEnum, cancelToken?: CancelToken): Promise<any> {
		try {
			const url = this.uspsMIDUrl + 'Admin/';
			const res = await axios.post<any>(url, data, {
				cancelToken,
				params: {
					type,
				},
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async getUSPSMIDsCount(cancelToken?: CancelToken): Promise<IUSPSMIDsCount> {
		try {
			const url = this.uspsMIDUrl + 'Count/';
			const res = await axios.get<IUSPSMIDsCount>(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/system-config.service.ts